import { TemplateName } from "../types";
import { NNR_DISPLAY_ID_TYPES } from "./alternateIdKinds";
import { NewlyNotReportingListTemplate } from "./listTemplate";
export class NewlyNotReportingAZTemplate extends NewlyNotReportingListTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.NewlyNotReportingAZ;
    }
    getDisplayIdType() {
        return NNR_DISPLAY_ID_TYPES.TIER2_AZ;
    }
}
//# sourceMappingURL=az.js.map